import { SearchConfig } from '~/models/search/config'
import { CategoryId } from '~/models/category/types'

export const wantedPartsSearchConfig: SearchConfig = Object.freeze({
  settings: {
    searchName: 'wanted-parts',
    searchbar: {
      autocompleteEndpoint: '/api/classifieds/query/',
      usesNuxtLinks: false
    },
    displayAds: false,
    isWantedPartsSearch: true
  },
  rootParams: {
    category: [CategoryId.WANTED_PARTS]
  }
})
